/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CourseMembershipRole =
  | 'CO_TEACHER'
  | 'GUEST'
  | 'NONE'
  | 'OWNER'
  | 'STUDENT'
  | 'SUB_TEACHER'
  | 'TEACHER';

/** Input for invalidating a course collaboration invite for a specific membership role or all */
export type InvalidateCourseCollaborationInput = {
  courseId: string;
  courseMembershipRole?: CourseMembershipRole | null | undefined;
};

export type InvalidateCourseCollaborationInviteMutationVariables = Exact<{
  invalidateCourseCollaborationInput: Types.InvalidateCourseCollaborationInput;
}>;


export type InvalidateCourseCollaborationInviteMutation = { invalidateCourseCollaborationInvite: { done: boolean } };


export const InvalidateCourseCollaborationInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InvalidateCourseCollaborationInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invalidateCourseCollaborationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidateCourseCollaborationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invalidateCourseCollaborationInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invalidateCourseCollaborationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invalidateCourseCollaborationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done"}}]}}]}}]} as unknown as DocumentNode<InvalidateCourseCollaborationInviteMutation, InvalidateCourseCollaborationInviteMutationVariables>;